import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../theme/theme';
import { barColor } from '../utils/format';

/**
 * Capacity utilization bar with booked/capacity + percent caption.
 * Colour follows the customer-facing demand rule (blue/orange/red).
 */
const ProgressBar: React.FC<{ booked: number; capacity: number; minWidth?: number; height?: number }> = ({
  booked, capacity, minWidth = 150, height = 8,
}) => {
  const pct = Math.round((booked / capacity) * 100) || 0;
  return (
    <Box sx={{ minWidth }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, mb: 0.5 }}>
        <span>{booked}/{capacity}</span>
        <Typography component="span" sx={{ color: colors.textSecondary, fontSize: 12 }}>{pct}%</Typography>
      </Box>
      <Box sx={{ height, borderRadius: '99px', bgcolor: colors.gray100, overflow: 'hidden' }}>
        <Box sx={{ height: '100%', borderRadius: '99px', width: `${pct}%`, bgcolor: barColor(pct) }} />
      </Box>
    </Box>
  );
};

export default ProgressBar;
